import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'PUBLIC_'

export function storesLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/stores`;
  const method = 'GET'

  return {
    type: `${parent}STORES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function storeLoad(id, filters){
  const url = `/anonymous/${API_VERSION_ONE}/stores/${id}`;
  const method = 'GET'

  return {
    type: `${parent}STORE_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function storeStaffsLoad(store_id, filters){
  const url = `/anonymous/${API_VERSION_ONE}/stores/${store_id}/staff_members`;
  const method = 'GET'

  return {
    type: `${parent}STORE_STAFFS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}
export function storeFirstAvailableSlotsLoad(store_id, filters){
  const url = `/anonymous/${API_VERSION_ONE}/stores/${store_id}/first_available_slots`;
  const method = 'GET'

  return {
    type: `${parent}STORE_FIRST_AVAILABLE_SLOTS_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function storeId(id) {
  return {
    type: `${parent}STORE_ID`,
    id,
  };
}

export function setFirstAvailable(isChecked) {
  return {
    type: `${parent}SET_FIRST_AVAILABLE`,
    isChecked,
  };
}

export function setSelectedDate(date) {
  return {
    type: `${parent}SET_SELECTED_DATE_ID`,
    date,
  };
}